import {Panel, PanelBody, PanelRow, SelectControl} from "@wordpress/components";
import {__} from '@wordpress/i18n';
import {useState} from '@wordpress/element';
import InputOption from "../../options/InputOption";
import ColorPicker from "../../options/ColorPicker";

export default function MainOptionsPanel({attributes, setAttributes}) {

    const types = [
        {
            label: __('Table', 'tier-pricing-table'),
            value: "table"
        },
        {
            label: __('Blocks', 'tier-pricing-table'),
            value: "blocks"
        },
        {
            label: __('Options', 'tier-pricing-table'),
            value: "options"
        },
        {
            label: __('Dropdown', 'tier-pricing-table'),
            value: "dropdown"
        }
    ];

    const [displayType, setDisplayType] = useState(attributes.displayType);

    return (
        <Panel>
            <PanelBody title={__('Main settings', 'tier-pricing-table')} initialOpen={true}>
                <PanelRow>
                    <SelectControl
                        label={__('Display type', 'tier-pricing-table')}
                        value={displayType}
                        options={types}
                        onChange={(displayType) => {
                            setAttributes({
                                displayType: displayType
                            });

                            setDisplayType((displayType));
                        }}
                    />
                </PanelRow>
                <PanelRow>
                    <InputOption attributes={attributes}
                                 setAttributes={setAttributes}
                                 attributeName="title"
                                 label={__("Title", 'tier-pricing-table')}

                    />
                </PanelRow>
                <PanelRow>
                    <ColorPicker attributes={attributes}
                                 colors={[
                                     {name: 'default', color: '#96598A'},
                                     {name: 'white', color: '#fff'},
                                     {name: 'black', color: '#000'},
                                     {name: 'woocommerce', color: '#8055B3'},
                                 ]}
                                 attributeName="activeTierColor"
                                 label={__("Active tier color")}
                                 setAttributes={setAttributes}
                                 clearable={false}
                    />
                </PanelRow>
            </PanelBody>
        </Panel>
    );
}
